import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@mui/material';
import { DialogContent } from '../core';

const ConfirmWithMessageContent = ({
    onCancel,
    onConfirm,
    children,
    translation = 'manager',
    title = null,
    header = null,
    showTextField = true,
}) => {
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'dialog' });
    const [message, setMessage] = useState('');

    const customTitle = title || t(`${translation}.title`);
    const customHeader = header || t('header');

    const handleConfirm = () => {
        const msg = showTextField ? message : '';
        onConfirm(msg);
    };

    return (
        <DialogContent
            title={customTitle}
            header={customHeader}
            cancelButton={{
                label: t('cancel'),
                onClick: () => onCancel()
            }}
            confirmButton={{
                label: t('confirm'),
                onClick: handleConfirm,
            }}
        >
            {children}
            {showTextField && (
                <TextField
                    className="confirm-dialog-content--text"
                    variant="outlined"
                    placeholder={t('comment')}
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                    multiline
                    minRows={4}
                />
            )}
        </DialogContent>
    );
};

export default ConfirmWithMessageContent;
